import { render, staticRenderFns } from "./messageTemplate.vue?vue&type=template&id=0b3892d6&scoped=true&"
import script from "./messageTemplate.vue?vue&type=script&lang=js&"
export * from "./messageTemplate.vue?vue&type=script&lang=js&"
import style0 from "./messageTemplate.vue?vue&type=style&index=0&id=0b3892d6&scoped=true&lang=scss&"
import style1 from "./messageTemplate.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3892d6",
  null
  
)

export default component.exports